import { createActionGroup, props } from '@ngrx/store';
import { Creative, ListCreativesRequest } from '@sites/data-hmm/hmm-incubator';
import { CreativeSearch } from './creative.models';

export const creativeServiceAction = createActionGroup({
  source: 'DashboardFeatureCreative Service',
  events: {
    get: props<{ creativeId: string }>(),
    list: props<{ search: CreativeSearch }>(),
    listSuccess: props<{
      creatives: Creative[];
    }>(),
    listFailure: props<{ error: Error }>(),
  },
});

export const creativeThumbnailComponentAction = createActionGroup({
  source: 'DashboardFeatureCreative ThumbnailComponent',
  events: {
    init: props<{ creativeId: string }>(),
    updateSearch: props<{ search: ListCreativesRequest }>(),
    loadGif: props<{ creativeId: string }>(),
    loadGifRaw: props<{ creativeId: string }>(),
    loadThumbnailRaw: props<{ creativeId: string }>(),
    loadRecording: props<{ creativeId: string }>(),
    loadRecordingRaw: props<{ creativeId: string }>(),
  },
});

export const creativeSearchComponentAction = createActionGroup({
  source: 'DashboardFeatureCreative SearchComponent',
  events: {
    init: props<{
      search: CreativeSearch;
    }>(),
    list: props<{
      search: CreativeSearch;
    }>(),
  },
});
